import { COMMON_EVENT_NAMES } from "../../../constants";

export const EVENTS = {
  NAVIGATE_TO: COMMON_EVENT_NAMES.NAVIGATED
};
